/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Swal_TitleInputs */

const en_signup_swal_title = /** @type {(inputs: Signup_Swal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complete Checkout in Browser`)
};

const fr_signup_swal_title = /** @type {(inputs: Signup_Swal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminer le Paiement dans le Navigateur`)
};

const de_signup_swal_title = /** @type {(inputs: Signup_Swal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaufvorgang im Browser abschließen`)
};

const it_signup_swal_title = /** @type {(inputs: Signup_Swal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completa il checkout nel browser`)
};

const ru_signup_swal_title = /** @type {(inputs: Signup_Swal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завершите оформление заказа в браузере.`)
};

const es_signup_swal_title = /** @type {(inputs: Signup_Swal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completar el pago en el navegador`)
};

const zh_cn2_signup_swal_title = /** @type {(inputs: Signup_Swal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在浏览器中完成结账`)
};

const ja_signup_swal_title = /** @type {(inputs: Signup_Swal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ブラウザでチェックアウトを完了する`)
};

const hi_signup_swal_title = /** @type {(inputs: Signup_Swal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ब्राउज़र में चेकआउट प्रक्रिया पूरी करें`)
};

const pt_pt2_signup_swal_title = /** @type {(inputs: Signup_Swal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finalize a compra no navegador`)
};

/**
* | output |
* | --- |
* | "Complete Checkout in Browser" |
*
* @param {Signup_Swal_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_swal_title = /** @type {((inputs?: Signup_Swal_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Swal_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_signup_swal_title(inputs)
	if (locale === "de") return de_signup_swal_title(inputs)
	if (locale === "it") return it_signup_swal_title(inputs)
	if (locale === "ru") return ru_signup_swal_title(inputs)
	if (locale === "es") return es_signup_swal_title(inputs)
	if (locale === "zh-CN") return zh_cn2_signup_swal_title(inputs)
	if (locale === "ja") return ja_signup_swal_title(inputs)
	if (locale === "hi") return hi_signup_swal_title(inputs)
	if (locale === "pt-PT") return pt_pt2_signup_swal_title(inputs)
	return en_signup_swal_title(inputs)
});